<template>
	<v-dialog
		v-model="localShowDialog"
		width="var(--sgnl-container-343)"
		persistent
		:z-index="2500"
	>
		<v-card>
			<div class="tour-leave-title sgnl-text-color-default sgnl-subtitle-medium">Leave tour?</div>
			<v-divider />
			<div class="tour-leave-text sgnl-text-color-default sgnl-paragraph-s-regular">
				Your tour progress will be lost. You can restart it later from the Help menu.
			</div>
			<v-divider />
			<div class="tour-leave-actions">
				<v-btn
					variant="outlined"
					@click="$emit('stay')"
				>
					Stay
				</v-btn>
				<v-btn
					variant="flat"
					color="primary"
					@click="$emit('leave')"
				>
					Leave
				</v-btn>
			</div>
		</v-card>
	</v-dialog>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
	name: "TourLeaveConfirmDialog",
	props: {
		showDialog: { type: Boolean, default: false },
	},
	emits: ["update:showDialog", "stay", "leave"],
	computed: {
		localShowDialog: {
			get(): boolean {
				return this.showDialog;
			},
			set(value: boolean) {
				this.$emit("update:showDialog", value);
			},
		},
	},
});
</script>

<style lang="scss" scoped>
.tour-leave-title {
	padding: var(--sgnl-space-12) var(--sgnl-space-24);
}

.tour-leave-text {
	padding: var(--sgnl-space-12) var(--sgnl-space-24);
}

.tour-leave-actions {
	display: flex;
	justify-content: flex-end;
	gap: var(--sgnl-space-8);
	padding: var(--sgnl-space-12) var(--sgnl-space-16);
	background: var(--sgnl-default-secondary-background);
	border-radius: 0 0 var(--sgnl-border-radius-8) var(--sgnl-border-radius-8);
}
</style>
